import { render, staticRenderFns } from "./StudentPracticalWorks.vue?vue&type=template&id=572e4e67&scoped=true"
import script from "./StudentPracticalWorks.vue?vue&type=script&lang=js"
export * from "./StudentPracticalWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e4e67",
  null
  
)

export default component.exports